import api from 'Application/api/api';

const getPlatforms = signal =>
	api.get('/platforms/get-pageable', {
		signal,
	});

export default getPlatforms;
